(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('ProductCategoryDetailController', ProductCategoryDetailController);

    ProductCategoryDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'ProductCategory'];

    function ProductCategoryDetailController($scope, $rootScope, $stateParams, entity, ProductCategory) {
        var vm = this;
        vm.productCategory = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:productCategoryUpdate', function(event, result) {
            vm.productCategory = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
